export default class Account {
    constructor(account, rates) {
        Object.assign(this, account)

        this.rates = rates
    }

    priceMonthly() {
        const rsdRate = this.rates && this.rates.rsd
        return {
            usd: this.base_price,
            rsd: rsdRate ? this.base_price * rsdRate : null
        }
    }

    priceAnnualy() {
        const rsdRate = this.rates && this.rates.rsd
        return {
            usd: this.annual_price,
            rsd: rsdRate ? this.annual_price * rsdRate : null
        }
    }

    getSubscriptionType(opt) {
        const type = this.type.toUpperCase()

        return `${this.type}-${opt}`
    }

    supportDescription() {
        if (this.support_type == 'email') {
            return 'accountSupportEmailDescription'
        }

        if (this.support_type == 'standard') {
            return 'accountSupportStandardDescription'
        }

        if (this.support_type == 'pro') {
            return 'accountSupportPremiumDescription'
        }
    }
} 